import { ref } from 'vue';
import useFormLevel from '@kanrisha/composables/useFormLevel';

export default function useForm(props, resource) {
  let legacyFormConfig;
  if (typeof resource.form.config !== 'undefined') {
    legacyFormConfig = resource.form.config;
  }
  const formConfig = ref(legacyFormConfig ?? resource.meta.form?.config ?? resource.form?.config);

  const formSections = ref(resource.form.sections);
  const { formLevel } = useFormLevel(props, resource);

  return {
    formSections,
    formLevel,

    formConfig,
  };
}
